import { type FC, useEffect } from 'react';

import { AccommodationSections } from '@vakantiesnl/components/src/utils/accoSections';
import { useAccoOfferStore } from '@vakantiesnl/services/src/stores/accommodationStore';
import { Element } from 'react-scroll';

import { useStyles } from './AccoOnlyBookingBlock.styles';
import { PriceOverview } from './PriceOverview';
import RoomType from './RoomType/RoomType';
import { TripOffersInfiniteScroll } from './TripOffers';
import { StickyOfferWrapper } from '../accommodation/StickyOfferWrapper/StickyOfferWrapper';

type Props = {
	isPriceInView?: boolean;
};

export const AccoOnlyBookingBlock: FC<Props> = ({ isPriceInView }) => {
	const { classes } = useStyles();
	const currentOffer = useAccoOfferStore((s) => s.accoOnlyRoomTypeOffer);

	const isLoadingCheapestOfferPerDay = useAccoOfferStore((s) => s.isDepartureDateLoading);

	useEffect(() => {
		if (window && window.scrollTo) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}, []);

	return (
		<div className={classes.bookingModule}>
			<Element name={AccommodationSections.AvailabilityOffers}>
				<TripOffersInfiniteScroll />
			</Element>
			<RoomType />
			{!!currentOffer && !isLoadingCheapestOfferPerDay && <PriceOverview selectedOffer={currentOffer} />}

			<StickyOfferWrapper isPriceInView={isPriceInView} />
		</div>
	);
};
